import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.75 6C2.33579 6 2 6.33579 2 6.75C2 7.16421 2.33579 7.5 2.75 7.5H21.25C21.6642 7.5 22 7.16421 22 6.75C22 6.33579 21.6642 6 21.25 6H2.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 11.75C6 11.3358 6.33579 11 6.75 11H17.25C17.6642 11 18 11.3358 18 11.75C18 12.1642 17.6642 12.5 17.25 12.5H6.75C6.33579 12.5 6 12.1642 6 11.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 16.6875C10 16.2733 10.3358 15.9375 10.75 15.9375H13.25C13.6642 15.9375 14 16.2733 14 16.6875C14 17.1017 13.6642 17.4375 13.25 17.4375H10.75C10.3358 17.4375 10 17.1017 10 16.6875Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgFilter;
